import { AnchorButton, Button, ButtonGroup } from "@blueprintjs/core";
import * as React from "react";
import { cleanCheckIns } from "../adminFunctions";
import copyBesslerTheme from "../adminFunctions/copyBesslerTheme";
import copyFossRoutesToAll from "../adminFunctions/copyFossRoutesToAll";
import { deleteTexnCheckIns } from "../adminFunctions/deleteCheckIn";
import deleteUser from "../adminFunctions/deleteUser";
import duplicateSite from "../adminFunctions/duplicateSite";
import { firestore } from "../firebase";

interface AdminState {
  csv: null | string;
  loadingCleanCheckIns: boolean;
  loadingCopy: boolean;
  loadingDeleteCheckIns: boolean;
  loadingDuplicate: boolean;
  loadingTheme: boolean;
}

class Admin extends React.Component<{}, AdminState> {
  public state: AdminState = {
    csv: null,
    loadingCleanCheckIns: false,
    loadingCopy: false,
    loadingDeleteCheckIns: false,
    loadingDuplicate: false,
    loadingTheme: false,
  };

  public render() {
    const {
      csv,
      loadingCleanCheckIns,
      loadingCopy,
      loadingDeleteCheckIns,
      loadingDuplicate,
      loadingTheme,
    } = this.state;

    return (
      <div
        style={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          minHeight: "10vh",
          width: "100%",
        }}
      >
        <Button
          onClick={() => {
            this.scratch();
          }}
        >
          Run scratch query
        </Button>
        {csv ? (
          <AnchorButton
            download="emails.csv"
            href={`data:text/csv;charset=utf-8,${csv}`}
          >
            download
          </AnchorButton>
        ) : (
          ""
        )}

        <hr />
        <ButtonGroup vertical={true}>
          <Button
            intent="danger"
            loading={loadingCleanCheckIns}
            onClick={this.cleanCheckIns}
          >
            Clean Check-Ins
          </Button>
          <Button
            intent="danger"
            loading={loadingCopy}
            onClick={this.copyRoutes}
          >
            Copy Routes
          </Button>
          <Button
            intent="warning"
            loading={loadingTheme}
            onClick={this.copyTheme}
          >
            Copy Theme
          </Button>
          <Button
            intent="primary"
            loading={loadingDuplicate}
            onClick={this.duplicateSite}
          >
            Duplicate Site
          </Button>
          <Button
            intent="danger"
            loading={loadingDeleteCheckIns}
            onClick={this.deleteTexnCheckIns}
          >
            Delete Texn CheckIns
          </Button>
          <Button
            intent="danger"
            loading={loadingDeleteCheckIns}
            onClick={this.deleteTestUser}
          >
            Delete Test User
          </Button>
        </ButtonGroup>
      </div>
    );
  }

  private scratch = async () => {
    console.log("changing bmw...");
    // const q = await firestore
    //   .collection("vehiclePicks")
    //   .where("model", "==", "530I")
    //   .get();

    // console.log(q.size);
    // const batch = firestore.batch();
    // q.forEach((doc) => {
    //   batch.update(doc.ref, {
    //     combined: "DODGE RAM PICKUP",
    //     model: "RAM PICKUP",
    //   });
    // });
    // batch.commit();

    // const fireSQL = new FireSQL(firestore);
    // const sql = "SELECT * FROM vehicles WHERE make = 'BMW' AND model LIKE '5%'";
    // fireSQL.query(sql).then((docs) => {
    //   console.log(docs.length);
    //   docs.forEach((doc) => {
    //     console.log(doc);
    //     doc.ref.update({ model: "5 SERIES" });
    //   });
    // });

    const q = await firestore
      .collection("vehicles")
      .where("make", "==", "SATURN")
      .where("model", ">=", "SL")
      .where("model", "<", "SL5")
      .get();
    console.log(q.size);
    q.forEach((doc) => {
      console.log(doc.data());
    });
  };

  private cleanCheckIns = async () => {
    this.setState({ loadingCleanCheckIns: true });

    const result = await cleanCheckIns();

    this.setState({ loadingCleanCheckIns: false });

    console.dir(result);
  };

  private copyRoutes = async () => {
    this.setState({ loadingCopy: true });

    const result = await copyFossRoutesToAll();

    this.setState({ loadingCopy: false });

    console.log(result);
  };

  private copyTheme = async () => {
    this.setState({ loadingTheme: true });

    const result = await copyBesslerTheme();

    this.setState({ loadingTheme: false });

    console.log(result);
  };

  private deleteTestUser = async () => {
    await deleteUser({ mobile: "", userId: "" });
  };

  private deleteTexnCheckIns = async () => {
    this.setState({ loadingDeleteCheckIns: true });

    const result = await deleteTexnCheckIns();

    console.log(`${result.length} checkIns deleted.`);

    this.setState({ loadingDeleteCheckIns: false });
  };

  private duplicateSite = async () => {
    this.setState({ loadingDuplicate: true });

    const result = await duplicateSite(
      "X1XG0gqud20k030bgepC",
      "ORNQVx1EgP5saTGTbw0M"
    );

    console.log(result);

    this.setState({ loadingDuplicate: false });
  };
}

export default Admin;



// WEBPACK FOOTER //
// ./src/views/Admin.tsx